import { lazy } from "react";
import { Route } from "react-router-dom";
const DashboardVENDOR = lazy(() => import("./DashboardVENDOR"));
const TosAlertContentComponent = lazy(() => import("components/v1/system/TosAlertContentComponent"));
const TosComponent = lazy(() => import("components/v1/system/TosComponent"));

const mainRoutes = 
<>
    <Route path="/front-page" element={<DashboardVENDOR />} />
    <Route path="/tos-acceptance" element={<TosAlertContentComponent />} />
    <Route path="/tos/:tosId" element={<TosComponent />} />
</>;
export default mainRoutes;